import { atom } from 'jotai';

export type ThemeMode = 'dark' | 'light';

export const THEME_STORAGE_KEY = 'kepler-theme-mode';

const getInitialThemeMode = (): ThemeMode => {
  if (typeof window === 'undefined') {
    return 'dark';
  }

  const storedTheme = window.localStorage.getItem(THEME_STORAGE_KEY);
  if (storedTheme === 'light' || storedTheme === 'dark') {
    return storedTheme;
  }

  const prefersDark = window.matchMedia
    ? window.matchMedia('(prefers-color-scheme: dark)').matches
    : true;
  return prefersDark ? 'dark' : 'light';
};

const siteThemeModeBaseAtom = atom<ThemeMode>(getInitialThemeMode());

export const siteThemeMode = atom(
  (get) => get(siteThemeModeBaseAtom),
  (_get, set, newTheme: ThemeMode) => {
    set(siteThemeModeBaseAtom, newTheme);

    if (typeof window !== 'undefined') {
      window.localStorage.setItem(THEME_STORAGE_KEY, newTheme);
    }
  },
);
